import { useCallback } from 'react';

import { TWO_FA_ERROR } from '../constants';
import { noop } from '@core/js/utils/methods.util';
import { getUserError, useGetErrorResponseMessage } from '@core/js/hooks/server';
import { useTwoFactorAuthenticationPopup } from '@core/js/components/popups/TwoFactorAuthenticationPopup/hooks/useTwoFactorAuthenticationPopup';

export const useFetchWithTwoFa = () => {
    const getErrorResponseMessage = useGetErrorResponseMessage();
    const showTwoFactorAuthenticationPopup = useTwoFactorAuthenticationPopup();

    return useCallback(({
        fetch,
        onError,
        afterFetch = noop,
        onCancelTwoFa = noop
    }) => {
        return fetch()
            .then(afterFetch)
            .catch((error) => {
                const { errorCode } = getUserError(error);

                if (errorCode === TWO_FA_ERROR) {
                    showTwoFactorAuthenticationPopup({
                        onSuccess: () => fetch().then(afterFetch),
                        resendHandler: fetch,
                        onCancel: onCancelTwoFa
                    });

                    return;
                }

                if (onError) {
                    return onError(error);
                }

                return getErrorResponseMessage(error);
            });
    }, [getErrorResponseMessage, showTwoFactorAuthenticationPopup]);
};
